<style lang="scss" scoped>
  .ARElementList {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding-bottom: 60px;

      @media only screen and (max-width: 770px) {
        padding-bottom: 120px;
        margin-left: 0;
        padding-left: 0;
      }

    .column {
      padding-top: 0;
      padding-bottom: 0;
    }

    &__title {
      height: 2rem;
      font-size: 14px;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.6px;
      text-align: left;
      color: #202020;
      display: inline-block;
    }

    &__filename {
      margin-left: 2rem;
    }

    &__close {
      float: right;
      margin-right: 1rem;
      margin-top: 0.5rem;
    }

    &__select-input {
      display: none;
    }
    &__serial {
      color: #202020;
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: 600;
      float: left;
    }
    &__removeRightmargin {
      margin-right: 0px;
    }
    &__autoWidth {
/*      width: auto;*/
    }
    &__borderHeight {
      height: 2.33rem;

      @media only screen and (max-width: 1000px) {
        height: 3rem;
      }
    }
    &__CursorPointer {
      cursor: pointer;

      @media only screen and (max-width: 770px) {
        margin-top: -2px;
        margin-right: 15px;
        margin-left: 15px;
      }
    }
    &__visibleButton {
      float: right;
      margin-right: 1.3rem;
      margin-top: 0.5rem;
      cursor: pointer;

      @media only screen and (max-width: 1000px) {
        margin-left: 0;
        margin-right: auto;
        float: right;
      }
      @media only screen and (max-width: 770px) {
        margin-right: auto;
        margin-top: -30px;
        float: right;
      }
    }
    &__DeleteButton {
      float: right;
      margin-right: 1.3rem;
      margin-top: 0.5rem;
      cursor: pointer;

      @media only screen and (max-width: 1000px) {
        margin-left: 0;
        margin-right: auto;
        float: right;
      }
      @media only screen and (max-width: 770px) {
        margin-right: 40px;
        margin-top: -28px;
        float: right;
      }
    }
  }
</style>

<template lang="pug">
  .ARElementList
    .columns(v-for="element, index in elements" :key="element.id").box.ARElementList__borderHeight.ARElementList__removeRightmargin.is-marginless
      .column.is-1
      .column.is-1
        .ARElementList__serial.is-paddingless {{ index + 1 }}
      .column.has-text-left.ARElementList__CursorPointer( @click="onItemClick(element)")
        .ARElementList__title {{element.name}}
      .column.is-1.ARElementList__autoWidth.is-paddingless
        span.is-pulled-right
          img(src="@/assets/img/close.png", @click="onDeleteClick(element)").ARElementList__DeleteButton
      .column.is-2.ARElementList__autoWidth
        span(@click="onEyeClick(element)").ARElementList__CursorPointer
          img.ARElementList__visibleButton(v-if="element.isVisible", src="@/assets/img/eye_smaller.png")
          img.ARElementList__visibleButton(v-else, src="@/assets/img/eye-disabled-smaller.png")

</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
    name: 'ARElementList',
    props: {
      title: String,
      buttonDisabledTitle: String,
    },
    computed: {
      ...mapState('Firebase', ['loadedARElements']),
      ...mapGetters('Firebase', ['getIsMarkerOnly']),
      elements(state) {
        // We need to filter the AR elements as per the room ID.
        // For now to test we will load all ar elements.
        return state.loadedARElements.filter(x => x.roomId === this.$route.params.id);
      },
      isMarkerOnly() {
        return this.getIsMarkerOnly;
      },
    },
    methods: {
      ...mapActions('Firebase', ['updateARElementVisibility', 'deleteARElement']),
      onDeleteClick(element) {
        // The click event will fire and here we can handle the action to delete the item.
        // We can replace the close icon with loader and remove the row once the process is complete.
        // or we can log/show the error if it occurs during deletion.
        this.deleteARElement(element);
      },
      onItemClick(element) {
        this.$router.push(`/ar-element/${element.id}`);
      },
      onEyeClick(element) {
        console.log(this.getIsMarkerOnly);
        console.log(this.title);
        const sentElement = {
          ...element,
          markerOnly: this.getIsMarkerOnly ? this.getIsMarkerOnly : false,
        };
        console.log(sentElement);
        this.updateARElementVisibility(sentElement);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/Room/components/ARElementList.vue